import type { ReactElement } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { noRowsOverlayContainer } from "./styles_vanilla.css";

export const NoRowsOverlay = (): ReactElement => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={noRowsOverlayContainer}
    >
      <Icon type="search" size="large" color={Colors.Neutral800} variant="solid" />
      <Text variant="regular-md" align="center">
        No client entities found
      </Text>
    </Flex>
  );
};
